import { useTranslation } from "react-i18next";
import { SubTitle, Text } from "../../common/texts";
import {
  Wrapper,
  Card,
  LeftContent,
  RightContent,
} from "./contributingSection.styles";
import img from "../../../assets/images/snakes/contributing.jpeg";

export const ContributingSection = () => {
  const { t } = useTranslation("home");
  return (
    <Wrapper>
      <Card>
        <LeftContent>
          <SubTitle $bold $color="#fff">
            {t("contributing.title")}
          </SubTitle>
          <Text $color="#dcdcdc">{t("contributing.description")}</Text>
        </LeftContent>
        <RightContent>
          <img src={img} alt="contributing" />
        </RightContent>
      </Card>
    </Wrapper>
  );
};
